<template>
<ai-test1></ai-test1>
<ai-test1></ai-test1>
</template>

<script>
export default {
  name: 'ai-grid-composition'
}
</script>

<style scoped>

</style>
